import http from '../../../../../libs/http'
export default (id) => http.put(`${process.env.VUE_APP_MICROSERVICE_API_PUBLICACIONES}/${id}/state`, { loading: true })
